import gql from "graphql-tag";
import RankedIssuerFields from "lib/fragments/RankedIssuerFields";

export default gql`
  mutation RateIssuer($input: RatingInput!) {
    rateIssuer(input: $input) {
      ... on BrazilianCompanyIssuer {
        _id
        ...RankedIssuerFields
      }
      ... on AmericanCompanyIssuer {
        _id
        ...RankedIssuerFields
      }
      ... on BrazilianRealEstateFund {
        _id
        ...RankedIssuerFields
      }
    }
  }

  ${RankedIssuerFields}
`;
